<template>
  <div class="list-number-container">
    <Title v-if="isShowHeader" :prefix="titlePrefix" :title="title">
      <ButtonCommon
        v-if="isShowLuckdip"
        text="lucky dip"
        class="button__custom"
        @action="handleLuckyDip"
      />
    </Title>
    <div class="number-content">
      <Number
        v-for="(n, i) in numbers"
        :key="i"
        :number="n.value"
        :bgColor="n.color_code"
        :isSelected="numbersSelected.some((x) => x.value == n.value)"
        @selectBall="handleSelectball(n)"
      />
    </div>
    <div class="number-action">
      <span class="mg-5">
        <ButtonCommon
          text="clear"
          class="button__clear button__custom-2"
          :isDisable="isDisableAddButton"
          @action="clearNumbers"
        />
      </span>
      <span class="mg-5">
        <ButtonCommon
          text="add"
          class="button__primary button__custom-2"
          :isDisable="isDisableAddButton"
          @action="addNumber"
        />
      </span>
    </div>
  </div>
</template>
<script>
import ButtonCommon from "@/components/common/button";
import Number from "@/components/common/number";
import Title from "@/components/common/title/index.vue";
import EventBus from "@/utils/EventBus";
import { requestAppLayoutUpdate } from "@/utils/app-layout";

export default {
  components: { ButtonCommon, Number, Title },
  props: {
    numbers: Array,
    title: String,
    titlePrefix: String,
    isShowHeader: { type: Boolean, default: true },
    isShowLuckdip: { type: Boolean, default: false },
    maxPick: Number,
    outcomes: Array,
    marketSlug: String,
  },
  data() {
    return {
      numbersSelected: [],
      isDisableAddButton: true,
      selectedOutcome: {},

      numberInQueue: null,
    };
  },
  watch: {
    marketSlug: {
      handler() {
        this.numbersSelected = [];
        this.checkDisableAddButton();
      },
      deep: true,
    },
    $route() {
      this.numbersSelected = [];
      this.checkDisableAddButton();
    },
  },
  created() {
    EventBus.on("clear-picks", this.clearNumbers);
    EventBus.on("selected-outcome", this.handleSelectedOutcome);
  },
  unmounted() {
    EventBus.off("clear-picks", this.clearNumbers);
    EventBus.off("selected-outcome", this.handleSelectedOutcome);
  },
  methods: {
    handleLuckyDip() {
      const availableNumbers = this.numbers.filter(
        (n) => !this.numbersSelected.some((item) => item.value === n.value)
      );

      if (availableNumbers.length < this.maxPick) {
        console.warn("Not enough available numbers for the lucky dip.");
        return;
      }

      this.numbersSelected = this.getRandomBalls(
        availableNumbers,
        this.selectedOutcome.pick
      );
      this.checkDisableAddButton();
      this.$emit("pick", this.numbersSelected.length);
    },

    getRandomBalls(arr, numObjects) {
      const shuffled = arr.slice();
      return shuffled.sort(() => Math.random() - 0.5).slice(0, numObjects);
    },

    handleSelectball(number) {
      const { value, color } = number;

      const index = this.numbersSelected.findIndex(
        (item) => item.value === value && item.color === color
      );

      console.log("🚀 -> list-number.vue:124 -> this.maxPick: ", this.maxPick);

      if (index !== -1) {
        this.numbersSelected.splice(index, 1);
      } else if (
        Object.keys(this.selectedOutcome).length === 0 &&
        this.numbersSelected.length < this.maxPick
      ) {
        this.numbersSelected.push(number);
      } else if (this.numbersSelected.length < this.selectedOutcome.pick) {
        this.numbersSelected.push(number);
      } else if (this.selectedOutcome.pick < this.maxPick) {
        this.numberInQueue = number;
        EventBus.emit("onMaxPickReached");

        return;
      }

      this.checkDisableAddButton();
      this.$emit("pick", this.numbersSelected.length);
    },

    checkDisableAddButton() {
      let picks = parseInt(this.selectedOutcome.pick);
      if (this.selectedOutcome && picks > 0) {
        this.isDisableAddButton = this.numbersSelected.length !== picks;
      } else {
        this.isDisableAddButton = this.numbersSelected.length === 0;
      }
    },

    addNumber() {
      if (this.numbersSelected.length === 0) {
        return;
      }

      EventBus.emit("add-number", {
        numbersSelected: this.numbersSelected,
        outcomes: this.outcomes,
        onSuccess: () => {
          this.numbersSelected = [];
          this.checkDisableAddButton();

          setTimeout(() => {
            requestAppLayoutUpdate();
          });
        },
      });
    },

    clearNumbers() {
      this.numbersSelected = [];
      this.checkDisableAddButton();
    },

    handleSelectedOutcome(outcome) {
      if (!outcome || outcome.id === this.selectedOutcome.id) {
        return;
      }

      this.selectedOutcome = outcome;

      this.$nextTick(() => {
        if (this.numberInQueue) {
          this.handleSelectball(this.numberInQueue);
          this.numberInQueue = null;
        }
        this.checkDisableAddButton();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/public/scss/components/coupons/list-number.scss";
</style>
